// DO NOT EDIT -- generated from fs/api/proactiveinsights/dxobjects.proto

import * as protobuf from '../../../google/protobuf';

export interface DxIdVersion {
  id: string;
  version: protobuf.int64;
  supportedDxObjectType: SupportedDxObjectType;
}

export enum SupportedDxObjectType {
  SUPPORTED_DX_OBJECT_TYPE_INVALID = 0,
  SUPPORTED_DX_OBJECT_TYPE_METRIC = 1,
  SUPPORTED_DX_OBJECT_TYPE_FUNNEL = 2
}
